import axios from "axios"

export const SERVER_URL = "https://food-delivery-01f3.onrender.com"

export const api = axios.create({
  baseURL: `${SERVER_URL}/api/v1`,
  withCredentials: true,
})

api.interceptors.response.use(
  (config) => {
    return config
  },
  async (error) => {
    const originalRequest = error.config

    if (
      error.response.status === 401 &&
      originalRequest &&
      !originalRequest._isRetry
    ) {
      originalRequest.isRetry = true

      try {
        const response = await axios.get(`${SERVER_URL}/api/v1`, {
          withCredentials: true,
        })

        return api.request(originalRequest)
      } catch (err) {}
    }
    throw error
  }
)
